// @ts-nocheck
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface NumberOfKeysRowProps {
  game: any;
  style: React.CSSProperties;
  gameNumberOfKeysOnBlur: (game: unknown) => void;
  changeNumberOfKeys: (value: string, game: unknown) => void;
}

function NumberOfKeysRow({
  game,
  style,
  gameNumberOfKeysOnBlur,
  changeNumberOfKeys,
}: NumberOfKeysRowProps) {
  const { t } = useTranslation();
  return (
    <div
      className={
        !game.isSKU
          ? 'grid-empty full-cell'
          : 'grid-empty full-cell sku sku-input'
      }
      style={style}
    >
      <input
        type="number"
        value={game.numberOfKeys || ''}
        onBlur={() => {
          if (!game.isSKU) {
            gameNumberOfKeysOnBlur(game);
          }
        }}
        placeholder={!game.isSKU ? t('Apply to skus') : '0'}
        className={!game.isSKU ? 'form-control num' : 'form-control sku num'}
        onChange={(e) => changeNumberOfKeys(e.target.value, game)}
        disabled={game.showRemove}
      ></input>
    </div>
  );
}

export default NumberOfKeysRow;
